import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Globle } from 'src/assets/globle';
import { ServiceOrders } from './serviceorder.model';

@Injectable({
  providedIn: 'root'
})
export class ServiceordersService {

  constructor(private http: HttpClient, private global: Globle) { }

  get(status: number, userId: string, fromDate: string, toDate: string) {
    return this.http.get<ServiceOrders[]>(this.global.APIURL + "serviceorder/get?status=" + status +
      "&userId=" + userId + "&fromDate=" + fromDate + "&toDate=" + toDate);
  }

  updateNotSeen() {
    return this.http.put(this.global.APIURL + "serviceorder/updatenotseen", "");
  }


  updateStatus(obj: any) {
    return this.http.put(this.global.APIURL + "serviceorder/updatestatus", obj);
  }

  getNotSeenCount() {
    return this.http.get<number>(this.global.APIURL + "serviceorder/getnotseen");
  }
}
